import _Wgkcj8wQ9FbGR57YLL8c from '../dictionary/about.json' with { type: 'json' };
import _wUwmGivr8ytEWSUCY8eL from '../dictionary/chorna.json' with { type: 'json' };
import _fu0mxkrTDaLlb3VQWIIy from '../dictionary/common.json' with { type: 'json' };
import _FolHVCsLPKEqKYSPvZdn from '../dictionary/cookie-policy-popup.json' with { type: 'json' };
import _CmSebRcOkCEcR3RtPhhh from '../dictionary/cookies.json' with { type: 'json' };
import _ojgmldoknASHz8eiobmc from '../dictionary/errors.json' with { type: 'json' };
import _7WQt0RHF4JTPv6oLf1Y3 from '../dictionary/footer.json' with { type: 'json' };
import _hfcnyvZsRq83jjP8L7De from '../dictionary/header.json' with { type: 'json' };
import _FAaQgBNpKZCa4KyemCrL from '../dictionary/jade.json' with { type: 'json' };
import _8hC3VLZz8cviacm1gH1w from '../dictionary/landing.json' with { type: 'json' };
import _QonSUaf2lKX7gauLA7YZ from '../dictionary/mobile-menu.json' with { type: 'json' };
import _IAacBfEHZgy2cd0A5VGX from '../dictionary/navigation.json' with { type: 'json' };
import _LA69GDEhrH7UhiHfvJKi from '../dictionary/privacy.json' with { type: 'json' };
import _9pAMPqkQzSbEqYGyx77u from '../dictionary/tactical-drones.json' with { type: 'json' };
import _pWdiivyEt8nXpoSjzTNj from '../dictionary/team-page.json' with { type: 'json' };
import _ewxE3r26J8sFKsqPttl5 from '../dictionary/vacancies.json' with { type: 'json' };

const dictionaries = {
  "about": _Wgkcj8wQ9FbGR57YLL8c,
  "chorna": _wUwmGivr8ytEWSUCY8eL,
  "common": _fu0mxkrTDaLlb3VQWIIy,
  "cookie-policy-popup": _FolHVCsLPKEqKYSPvZdn,
  "cookies": _CmSebRcOkCEcR3RtPhhh,
  "errors": _ojgmldoknASHz8eiobmc,
  "footer": _7WQt0RHF4JTPv6oLf1Y3,
  "header": _hfcnyvZsRq83jjP8L7De,
  "jade": _FAaQgBNpKZCa4KyemCrL,
  "landing": _8hC3VLZz8cviacm1gH1w,
  "mobile-menu": _QonSUaf2lKX7gauLA7YZ,
  "navigation": _IAacBfEHZgy2cd0A5VGX,
  "privacy": _LA69GDEhrH7UhiHfvJKi,
  "tactical-drones": _9pAMPqkQzSbEqYGyx77u,
  "team-page": _pWdiivyEt8nXpoSjzTNj,
  "vacancies": _ewxE3r26J8sFKsqPttl5
};
const getDictionaries = () => dictionaries;

export { getDictionaries };
export default dictionaries;
